import React from 'react';
import { TrygError } from './styles';

export default ({ message }) => <TrygError>{message}</TrygError>;
